import { render, staticRenderFns } from "./giveback.vue?vue&type=template&id=2a403d82&"
import script from "./giveback.vue?vue&type=script&lang=js&"
export * from "./giveback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports